import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Server, ArrowRight } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav(next);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="container-pad min-h-[80vh] py-16 flex">
      <div className="m-auto w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <span className="inline-flex h-8 w-8 items-center justify-center bg-signal text-black rounded-sm">
            <Server size={16} strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg tracking-tight">
            Cloud<span className="text-signal">Rent</span>
          </span>
        </Link>
        <div className="overline">// AUTHENTICATE</div>
        <h1 className="mt-3 font-display text-3xl tracking-tight">Log in to your dashboard</h1>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="label-flat">EMAIL</label>
            <input
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-flat"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="label-flat">PASSWORD</label>
            <input
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-flat"
              placeholder="••••••••"
            />
          </div>

          {err && (
            <div data-testid="login-error" className="border border-red-900/60 bg-red-950/30 text-red-300 text-sm p-3 rounded-sm font-mono">
              {err}
            </div>
          )}

          <button
            type="submit"
            data-testid="login-submit-button"
            disabled={busy}
            className="btn-signal w-full h-11 text-sm font-mono tracking-widest disabled:opacity-50"
          >
            {busy ? "AUTHENTICATING…" : "LOG IN"} {!busy && <ArrowRight size={16} />}
          </button>

          <div className="text-center text-zinc-500 text-sm">
            No account?{" "}
            <Link to="/register" className="text-signal hover:underline">
              Create one
            </Link>
          </div>
        </form>

        <div className="mt-10 card-flat p-4 font-mono text-[11px] text-zinc-500 leading-5">
          <div className="text-zinc-400 mb-1">// TEST ADMIN</div>
          admin@cloudrentvps.com · Admin12345!
        </div>
      </div>
    </div>
  );
}
